import { useIsClient } from 'usehooks-ts';

type Props = {
  children: React.ReactNode;
};

export function ClientOnly({ children }: Props) {
  const isClient = useIsClient();
  return isClient ? children : null;
}
